import { defineComponent, computed, createVNode, mergeProps } from "vue";
import Checkbox from "../checkbox/index.js";
import { getPrefixCls } from "../_utils/global-config.js";
import IconRight from "../icon/icon-right/index.js";
import { getCheckedStatus } from "./utils.js";
import { isFunction } from "../_utils/is.js";
var CascaderOption = defineComponent({
  name: "CascaderOption",
  props: {
    option: {
      type: Object,
      required: true
    },
    computedKeys: {
      type: Array,
      required: true
    },
    isActive: Boolean,
    multiple: Boolean,
    expandTrigger: {
      type: String
    }
  },
  emits: ["clickOption", "activeChange", "pathChange"],
  setup(props, {
    emit
  }) {
    const prefixCls = getPrefixCls("cascader-option");
    const events = {};
    if (!props.option.disabled) {
      events.onMouseenter = [() => emit("activeChange", props.option)];
      events.onMouseleave = () => emit("activeChange");
      if (props.option.isLeaf && !props.multiple) {
        events.onClick = () => {
          emit("clickOption", props.option);
          emit("pathChange", props.option);
        };
      } else if (props.expandTrigger === "hover") {
        events.onMouseenter.push(() => emit("pathChange", props.option));
      } else {
        events.onClick = () => emit("pathChange", props.option);
      }
    }
    const cls = computed(() => [prefixCls, {
      [`${prefixCls}-active`]: props.isActive,
      [`${prefixCls}-disabled`]: props.option.disabled
    }]);
    const checkedStatus = computed(() => getCheckedStatus(props.option, props.computedKeys));
    const renderLabelContent = () => {
      if (isFunction(props.option.render)) {
        return props.option.render();
      }
      return props.option.label;
    };
    return () => createVNode("li", mergeProps({
      "class": cls.value
    }, events), [props.multiple && createVNode(Checkbox, {
      "modelValue": checkedStatus.value.checked,
      "indeterminate": checkedStatus.value.indeterminate,
      "disabled": props.option.disabled,
      "onClick": (e) => {
        emit("clickOption", props.option, !checkedStatus.value.checked);
        emit("pathChange", props.option);
      }
    }, null), createVNode("div", {
      "class": `${prefixCls}-label`
    }, [renderLabelContent(), !props.option.isLeaf && createVNode(IconRight, null, null)])]);
  }
});
export { CascaderOption as default };
